import { Card, LinearProgress, Paper, Typography } from "@mui/material";
import { Grid } from "@mui/system";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import CloseIcon from "@mui/icons-material/Close";

const FileUploadActionItem = ({
  isDragging,
  setIsDragging,
  handleFileDrop,
  handleFileUpload,
  uploadedFiles,
  handleRemoveFile,
}: any) => {
  return (
    <>
      <Grid container spacing={2} mt={2}>
        <Typography>Attachments</Typography>
        <Grid size={12}>
          <Card sx={{ padding: 2 }}>
            <Paper
              sx={{
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
                gap: 2,
                padding: 4,
                backgroundColor: isDragging ? "#f3e5f5" : "#f9f9f9",
                border: isDragging ? "2px dashed #9C27B0" : "none",
              }}
              onDragOver={(event) => {
                event.preventDefault();
                setIsDragging(true);
              }}
              onDragLeave={() => setIsDragging(false)}
              onDrop={handleFileDrop}
            >
              <UploadFileIcon color="secondary" fontSize="large" />
              <Typography
                component="label"
                sx={{ display: "flex", gap: 1, cursor: "pointer" }}
              >
                <Typography
                  color="secondary"
                  sx={{ textDecoration: "underline", cursor: "pointer" }}
                >
                  Click to upload
                </Typography>
                <input
                  data-tracker="113"
                  type="file"
                  multiple
                  accept=".png, .jpg, .jpeg, .pdf"
                  style={{ display: "none" }}
                  onChange={handleFileUpload}
                />
                or drag and drop
              </Typography>
              <Typography sx={{ color: "#9e9e9e" }}>
                PNG, JPG or PDF (max. 5MB)
              </Typography>
            </Paper>

            {uploadedFiles?.length > 0 &&
              uploadedFiles?.map((file: any, index: any) => (
                <Card
                  key={index}
                  sx={{
                    padding: "8px 16px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "16px",
                  }}
                >
                  <div>
                    <Typography sx={{ fontWeight: "500" }}>
                      {file.file.split("/").pop()}
                    </Typography>
                    <Typography sx={{ paddingBottom: "4px" }}>
                      {(file.size / 1024).toFixed(2)} KB • {file.status}
                    </Typography>
                    <LinearProgress
                      color="secondary"
                      variant="determinate"
                      value={file.progress}
                    />
                  </div>
                  <CloseIcon
                    sx={{ cursor: "pointer" }}
                    onClick={() => handleRemoveFile(index)}
                  />
                </Card>
              ))}
          </Card>
        </Grid>
      </Grid>
    </>
  );
};

export default FileUploadActionItem;
